import { Gamepad2, Monitor, Ticket } from "lucide-react";
import { useLang } from "./LangContext";

const iconFor = (label) => {
  const l = label.toLowerCase();
  if (l.includes("ps5") || l.includes("playstation") || l.includes("konsol")) return Gamepad2;
  if (l.includes("bilet") || l.includes("ticket")) return Ticket;
  return Monitor;
};

export const PriceItems = ({ items, testid }) => {
  const { lang, t } = useLang();
  const list = (items || []).filter((item) => item.label?.trim() && item.price != null);
  if (!list.length) return null;
  const fmt = new Intl.NumberFormat(lang === "tr" ? "tr-TR" : "en-GB", { maximumFractionDigits: 2 });
  return (
    <ul className="price-items" data-testid={testid}>
      {list.map((item, i) => {
        const Icon = iconFor(item.label);
        return (
          <li key={`${item.label}-${i}`} className="price-item" data-testid={`${testid}-${i}`}>
            <Icon size={15} aria-hidden="true" />
            <span className="price-item-label">{item.label}</span>
            <span className="price-item-value">
              {fmt.format(item.price)} TL
              <small>{item.unit === "flat" ? t.pricing.flat : `/ ${t.pricing.hour}`}</small>
            </span>
          </li>
        );
      })}
    </ul>
  );
};
